import React from "react";
import { PersistGate } from "redux-persist/es/integration/react";


import { Provider } from "react-redux";
import { store, persistor } from "./src/redux";

import GameUserLogin from "./src/pages/Login";
import {showLoading,Dialog,Loading,ErrorBoundary} from 'baziigram'
import  "baziigram/dist/main.css";
require("./src/styles/global.css");
require("./src/styles/home.css");
require("./src/styles/arrow.css");



const onBeforeLift = () => {
    // take some action before the gate lifts
};

export const registerServiceWorker = ({}) => {
    showLoading(true)
    console.log("Service Worker : Register")
    return true;
}

export const onServiceWorkerUpdateFound = ({serviceWorker}) => {
    console.log("Service Worker : Update found!")
    showLoading(true)
}

export const onServiceWorkerUpdateReady = ({serviceWorker}) => {
    console.log("Service Worker : Update ready!")
    showLoading(false)
    window.location.reload(true)
}

export const onServiceWorkerInstalled = ({serviceWorker}) => {
    console.log("Service Worker : Update Installed!")
    showLoading(false)
    window.location.reload(true)
}

export const onServiceWorkerActive = ({serviceWorker, event}) => {
    showLoading(false)
    console.log("Service Worker : Update Activated!")
}

export const wrapRootElement = ({ element }) => {
    return (
        <Provider store={store}>
            <PersistGate onBeforeLift={onBeforeLift} persistor={persistor}>
                <ErrorBoundary>
                    {element}
                    <Dialog />
                    <GameUserLogin/>
                    <Loading />
                </ErrorBoundary>
            </PersistGate>
        </Provider>
    );
};


export const onInitialClientRender = () => {
    window.addEventListener('popstate', () =>
        window.dispatchEvent(new CustomEvent("back-is-clicked"))
    )
}